import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LocaleDateFormats } from '../enums/date-format.enum';
import { Inject, Injectable } from '@angular/core';
import { LanguageCode } from '../enums/language-code.enum';

@Injectable({ providedIn: 'root' })
export class LocaleDateFormatHelper {
  constructor(@Inject(MAT_DATE_LOCALE) private locale: any) {}

  getDateFormat(): string {
    return LocaleDateFormats[this.locale] || LocaleDateFormats[LanguageCode.enGB];
  }

  getCustomDateFormats() {
    const dateFormat = this.getDateFormat();
    return {
      parse: {
        dateInput: dateFormat,
      },
      display: {
        dateInput: dateFormat,
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    };
  }
}
